// Antigüedad de una Ficha TI abierta y si la persona ya ingresó.

const DIA = 86400000;

// La lista de empleados manda las fechas como "Mon, 12 Oct 2026 00:00:00 GMT" y el
// wizard como "2026-10-12". Se lleva todo a medianoche local del día que dice.
const aFechaLocal = (valor) => {
  if (!valor) return null;
  const texto = String(valor);
  const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  const d = new Date(texto);
  return Number.isNaN(d.getTime()) ? null : new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};

const hoyLocal = () => {
  const h = new Date();
  return new Date(h.getFullYear(), h.getMonth(), h.getDate());
};

export const fechaCorta = (fecha) => (fecha ? fecha.toLocaleDateString('es-VE', { day: 'numeric', month: 'short' }) : '');

export function estadoFicha({ fecha_ingreso: fechaIngreso, ficha_desde: fichaDesde }) {
  const hoy = hoyLocal();
  const desde = aFechaLocal(fichaDesde);
  const ingreso = aFechaLocal(fechaIngreso);
  const dias = desde ? Math.max(0, Math.round((hoy - desde) / DIA)) : null;
  const yaIngreso = Boolean(ingreso && ingreso <= hoy);
  return {
    dias,
    ingreso,
    yaIngreso,
    diasDesdeIngreso: yaIngreso ? Math.round((hoy - ingreso) / DIA) : null,
    diasParaIngreso: ingreso && !yaIngreso ? Math.round((ingreso - hoy) / DIA) : null,
  };
}

export const textoDias = (n) => (n === 1 ? '1 día' : `${n} días`);
